import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const container = document.getElementById('root');

// react-snap pre-renders pages to static HTML during build.
// On those pages, use hydrateRoot so React attaches to existing DOM
// without re-rendering from scratch (faster, no flash of blank content).
// On normal client-side navigations, fall back to createRoot.
if (container.hasChildNodes()) {
  hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}